/** Feature flags pour l'optimisation du changement d'onglet cartographie. */
export const MAP_SWITCH_FAST_PATH =
  process.env.REACT_APP_MAP_SWITCH_FAST_PATH !== 'false';

export const STAKEHOLDER_CACHE_PERSIST =
  process.env.REACT_APP_STAKEHOLDER_CACHE_PERSIST !== 'false';

export const INCREMENTAL_SHEET_SWITCH =
  process.env.REACT_APP_INCREMENTAL_SHEET_SWITCH === 'true';

/** Active switchSheet incrémental automatiquement au-delà de ce nombre de blocs. */
export const AUTO_INCREMENTAL_BLOCK_THRESHOLD = 60;

/** Seuil (caractères JSON swimlane) pour différer le parsing au changement de feuille. */
export const LARGE_SWIMLANE_JSON_CHARS = 200_000;

/** Préchargement batch GET /mapping/sheets/batch (actif par défaut). */
export const MAP_BATCH_PREFETCH =
  process.env.REACT_APP_MAP_BATCH_PREFETCH !== 'false';
